import { useNavigate } from 'react-router-dom'
// import { useContext } from "react"
import img_1 from "../../assets/img/1927.jpg"
import img_2 from "../../assets/img/img_2.png"
import img_3 from "../../assets/img/img_3.png"
import img_4 from "../../assets/img/img_4.png"
import img_5 from "../../assets/img/img_5.png"
import img_6 from "../../assets/img/img_6.png"
import img_7 from "../../assets/img/img_2.jpg"
import img_8 from "../../assets/img/img_8.png"
import img_9 from "../../assets/img/img_9.png"
import img_10 from "../../assets/img/img_10.png"
import { urlBack } from 'utils/urlEnpoint'
// import { ProductosContext } from 'context/productos_context'
// import { Description } from '@mui/icons-material'


const EnviarData = async (url, data) => {
    try {
        const resp = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                // "Authorization": `Bearer ${token}`
            },
            mode: "cors",
        });

        if (!resp.ok) {
            const errorText = await resp.text();
            throw new Error(`Error en la respuesta del servidor: ${resp.status} ${errorText}`);
        }

        return await resp.json();
    } catch (error) {
        console.error("Error al enviar los datos:", error);
        return { error: error.message };
    }
};

function Noticias() {

    const navigate = useNavigate()
    let noticiasPost = [
        // {
        //     id: 1,
        //     titulo: "Reforma minera: cuando el desconocimiento paraliza un pilar de la economía",
        //     description: "Crítica a los diputados que aprobaron la reforma a la Ley Minero y que, gracias a su desconocimiento en la materia, paralizaron un pilar de la economía mexicana que solo el 2023 generó una riqueza de más de 269,000 millones de pesos. Este impasse frenó trámites y permisos y congeló una inversión estimada en 12,000 millones de dólares, capaces de fluir en sólo dos años. En un contexto internacional marcado por tensiones como la crisis arancelaria, dicha inversión representaría oxígeno puro para la economía mexicana y una señal de confianza para los mercados",
        //     tipo: "PERSPECTIVA ESTRATÉGICA",
        //     fecha: "20 de Mayo del 2025",
        //     titular: "El observador"
        // },
        {
            id: 2,
            titulo: "Sin minería no habrá un Plan México exitoso",
            description: "Sí, el Plan México es una estrategia robusta para pelear en la guerra comercial del presidente de Estados Unidos, Donald Trump, pero su éxito se puede ver mermado si no se dinamiza uno de los pilares de la economía mexicana: la minería, que hoy está paralizada a causa de la reforma a la Ley Minera que aprobó el Congreso de la Unión y cuya constitucionalidad revisa la Suprema Corte de Justicia de la Nación (SCJN).",
            tipo: "PERSPECTIVA ESTRATÉGICA",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 3,
            titulo: "Minería mexicana, rezagada frente a Chile o Perú por impasse de la reforma minera",
            description: "Para mejorar algo se debe medir, tan simple y básico como eso. Y cuando hablamos de minería, una de las mediciones más confiables a nivel internacional es la que realiza el Instituto Fraser. Gracias a sus estudios, índices y seguimiento de la industria vemos que mientras que países como Chile y Perú se preparan para un ciclo alcista en la producción e inversión minera durante 2025.",
            tipo: "PERSPECTIVA ESTRATÉGICA",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 4,
            titulo: "¿Por qué Olinia, el auto eléctrico de Sheinbaum, no será posible sin la minería?",
            description: "Seamos claros: Olinia, el primer auto eléctrico de manufactura mexicana, promovido por la presidenta Claudia Sheinbaum, es una gran noticia para la industria automotriz mexicana. No hay duda de que es un acierto, como tampoco la hay de que veremos la primera unidad rodar en el Estadio Azteca el 11 de junio de 2026, en el marco de la inauguración de la Copa Mundial de la FIFA, de la que México es sede, junto con Estados Unidos y Canadá.",
            tipo: "PERSPECTIVA ESTRATÉGICA",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 5,
            titulo: "Cómo te cuentan la minería vs cómo en realidad es",
            description: "La minería de hoy no es como la de antes, por mucho que se diga lo contrario. La industria se ha transformado, logrando reducir su impacto ambiental e incrementando su valor para la economía nacional y las comunidades locales.",
            tipo: "IMPACTO Y TRANSFORMACIÓN",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 6,
            titulo: "10 mentiras",
            description: "En los últimos años, la minería mexicana ha sido blanco de críticas que, si bien parten de dudas legítimas, frecuentemente están relacionadas con mitos o desinformación. En  LA VERDAD MINERA nos dimos a la tarea de detectar los errores más comunes que se difunden acerca de esta industria para informar sobre la relevancia y actualidad de esta actividad productiva.",
            tipo: "IMPACTO Y TRANSFORMACIÓN",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 7,
            titulo: "Así sería un día sin minería en México",
            description: "La industria minera mexicana es un pilar estratégico para la economía nacional y global. De acuerdo con estimaciones de la Cámara Minera de México (Camimex), si este sector se hubiera paralizado sólo un día en 2023 habría registrado pérdidas económicas por 736.9 millones de dólares (mdd), además de dejar de aportar 134.2 millones de pesos (mdp) a la recaudación de impuestos.",
            tipo: "IMPACTO Y TRANSFORMACIÓN",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 8,
            titulo: "¿Por qué la transición energética del gobierno de México depende de la minería?",
            description: "La creciente apuesta global por energías limpias y una economía baja en carbono ha intensificado la demanda de minerales críticos, fundamentales para el desarrollo de tecnologías sostenibles. La transición energética implica el uso de diferentes minerales, como el cobre, que destaca por su alta conductividad eléctrica y térmica, lo que lo convierte en un componente esencial para las tecnologías de energía renovable.",
            tipo: "IMPACTO Y TRANSFORMACIÓN",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 9,
            titulo: "La minería antes de la reforma VS La minería después de la reforma",
            description: "Una polémica reforma aprobada en 2023 cambió las reglas del juego en esta industria que aporta 2.7% del PIB nacional.¿Qué se perdió con el nuevo modelo? En La Verdad Minera presentamos las  comparaciones clave.",
            tipo: "IMPACTO Y TRANSFORMACIÓN",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
        {
            id: 10,
            titulo: "La importancia de la minería mexicana en números",
            description: "La industria minera es un pilar de la economía mexicana y es la base para otras 70 industrias de gran importancia para la actividad productiva del país. En La Verdad Minera presentamos una numeraria del sector",
            tipo: "MINERÍA COTIDIANA",
            fecha: "20 de Mayo del 2025",
            titular: "El observador"
        },
    ]
    // const { orden } = useContext(ProductosContext)
    // const [noticias, setNoticias] = useState(noticiasPost)


    const postPublicaciones = async (id) => {
        const data = {
            id
        }
        const respJson = await EnviarData(`${urlBack}publicaciones.php`, data);

        // console.log(respJson, "res")
        if (respJson.success === 'Click registrado correctamente') {

            navigate(`/publicacion/${id}`)
            // console.log("navegar")
        }

    }


    return (
        <div className="width-70 w-responsive">
            <div>
                {noticiasPost.map((noticia, i) => {
                    return (
                        
                        <div key={i}>
                            <div
                                // className={orden ==="Perspectiva" | orden === "Impacto" | orden === "Mineria" ?'d-md-lg d-lg-flex justify-content-center align-items-start  my-5 active-new-1' :'d-md-lg d-lg-flex justify-content-center align-items-start  my-5 ' }
                                className='d-md-lg d-lg-flex justify-content-center align-items-start  my-5'
                            >

                                <div className='text-center'>
                                    <img
                                        className='minutura'
                                        src={noticia.id === 1 ? img_1 : noticia.id === 2 ? img_2 : noticia.id === 3 ? img_3 : noticia.id === 4 ? img_4 : noticia.id === 5 ? img_5 : noticia.id === 6 ? img_6 : noticia.id === 7 ? img_7 : noticia.id === 8 ? img_8 : noticia.id === 9 ? img_9 : noticia.id === 10 ? img_10 : null}
                                        alt="miniatura"
                                    />
                                </div>

                                <div className='ms-4 margin-hide-mobile'>
                                    <h2 className='text-between text-bold mt-5 marginTop-hide'>{noticia.titulo}</h2>
                                    <p className='text-medium text-justify my-5'>{noticia.description}</p>
                                    <div className="d-flex justify-content-start">
                                        <div className="cta-leerMas my-3" onClick={() => {
                                            postPublicaciones(noticia.id)
                                        }}>Leer Más</div>
                                    </div>
                                    <div className='d-lg-flex text-medium'>
                                        <div><span className='text-bold'>Autor: </span>{noticia.titular}</div>
                                        <div className='margin-x-mobile'><span className='text-bold ms-3 margin-hide-mobile'>Fecha: </span>{noticia.fecha}</div>
                                        <div className="col"></div>
                                        <div className="pildora">{noticia.tipo}</div>
                                    </div>

                                </div>

                                <div className='borderBottom-blue'></div>
                            </div>
                        </div>

                    )
                })}
            </div>

        </div>

    )
}

export default Noticias